import {CommonModule} from '@angular/common';
import {Component, Input} from '@angular/core';
import {TranslateModule} from '@ngx-translate/core';
import {InvoiceWebhook} from '@gatewee/types/payment';
import {GateweeCollapsibleDirective} from '../gatewee-collapsible/gatewee-collapsible.directive';
import {GateweeExpandChevronComponent} from '../gatewee-expand-chevron/gatewee-expand-chevron.component';
import {GateweeIconComponent} from '../gatewee-icon/gatewee-icon.component';

@Component({
  selector: 'gatewee-webhook-metadata',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    GateweeIconComponent,
    GateweeExpandChevronComponent,
    GateweeCollapsibleDirective,
  ],
  templateUrl: './gatewee-webhook-metadata.component.html',
  styleUrls: [
    './gatewee-webhook-metadata.component.css',
    '../styles/gatewee-collapsible-details.css',
  ],
})
export class GateweeWebhookMetadataComponent {
  @Input() webhook: InvoiceWebhook | null | undefined;

  /** Invoice / checkout webhook endpoint (shown in the expanded panel when set). */
  @Input() webhookUrl: string | null | undefined;

  get displayWebhookUrl(): string {
    const u = this.webhookUrl?.trim();
    return u ?? '';
  }

  /** Pretty-printed headers JSON (same approach as `formattedResponse`). */
  get formattedHeaders(): string {
    const raw = this.webhook?.headers;
    if (!raw || typeof raw !== 'string') {
      return '';
    }
    try {
      const parsed = JSON.parse(raw) as unknown;
      return JSON.stringify(parsed, null, 2);
    } catch {
      return raw;
    }
  }

  /** Pretty-printed response body (object, JSON string, or plain text). */
  get formattedResponse(): string {
    const w = this.webhook;
    if (!w) {
      return '';
    }
    const r = w.response;
    if (typeof r === 'object' && r !== null) {
      try {
        return JSON.stringify(r, null, 2);
      } catch {
        return String(r);
      }
    }
    if (typeof r === 'string') {
      try {
        const parsed = JSON.parse(r) as unknown;
        return JSON.stringify(parsed, null, 2);
      } catch {
        return r;
      }
    }
    return String(r);
  }

  httpStatusBadgeClass(code: number): string {
    if (code >= 200 && code < 300) {
      return 'gw-bg-status-positive-pale gw-text-text-primary';
    }
    if (code >= 400) {
      return 'gw-bg-status-negative-pale gw-text-text-primary';
    }
    return 'gw-bg-status-neutral gw-text-text-primary';
  }
}
